import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsm-va-roi-teaser-m1');
	},
};
